"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "createCheckout", {
    enumerable: true,
    get: ()=>createCheckout
});
const _graphqlRequest = require("graphql-request");
const _checkoutFragment = require("../fragments/checkout-fragment");
const createCheckout = (0, _graphqlRequest.gql)`
    mutation CreateCheckout(
        $retailerId: ID!
        $address: CheckoutAddressInput
        $orderType: OrderType!
        $pricingType: PricingType!
        $metadata: JSON
        $trackedCartMetaData: TrackedCartMetaDataInput
    ) {
        createCheckout(
            retailerId: $retailerId
            address: $address
            orderType: $orderType
            pricingType: $pricingType
            metadata: $metadata
            trackedCartMetaData: $trackedCartMetaData
        ) {
            ...checkoutFragment
        }
    }
    ${_checkoutFragment.CHECKOUT_FRAGMENT}
`;
